import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id?: string;
  label?: string;
};

export const useArticleCategorySet = () => {
  const [ArticleCategorySetLoading, setArticleCategorySetLoading] =
    useState(false);
  const [ArticleCategorySet, setArticleCategorySet] = useState([]);

  const getArticleCategorySet = useCallback(async (params: TParams) => {
    setArticleCategorySetLoading(true);
    const res = await request({
      path: "article-category/set",
      method: "POST",
      body: JSON.stringify(params),
    });
    setArticleCategorySet(res?.data);
    setArticleCategorySetLoading(false);
    return res?.data;
  }, []);

  return { ArticleCategorySetLoading, ArticleCategorySet, getArticleCategorySet };
};
